import { render, staticRenderFns } from "./SignInMain.vue?vue&type=template&id=5b7c7ff4&"
import script from "./SignInMain.vue?vue&type=script&lang=js&"
export * from "./SignInMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports